import { useQuery } from '@tanstack/react-query';
import { ConfigurationSettings } from '../models/configuration-settings';
import {
  getConfigurationSettings,
  getSiteConfigurationSettings,
} from '../services/configuration-service';
import { useConfigStore } from '../state/store/config/useConfigStore';
import { SiteConfigurationSettings } from '../models/site-configuration-settings';

export const useConfigurationSettings = () => {
  return useQuery<ConfigurationSettings>({
    queryKey: ['getConfigurationSettings'],
    queryFn: () => getConfigurationSettings(),
  });
};

export const useSiteConfigurationSettings = (options?: { enabled?: boolean }) => {
  const { configurationSettings } = useConfigStore();

  return useQuery<SiteConfigurationSettings>({
    queryKey: ['getSiteConfigurationSettings'],
    queryFn: () => getSiteConfigurationSettings(),
    enabled: (options?.enabled ?? true) && !!configurationSettings,
  });
};
